/**
 * Extracts values from an object and returns them as an array.
 * @param {object} obj - The object from which values are extracted.
 * @returns {Array}    - The array of values extracted from the object.
 */
export const extractObjectValues = (obj) => Object.values(obj ?? {});

export default extractObjectValues;
